import React from 'react'
import "./Inputs.scss"
import { Autocomplete, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { UseFormRegisterReturn } from 'react-hook-form';


export interface IChoice {
    title: string,
    value: any
}

interface ISelectInput {
    label?: string;
    value?: any;
    choices: IChoice[];
    default?: IChoice;
    register: UseFormRegisterReturn;
}


function SelectInput({ register, value, ...props }: ISelectInput) {
    const [curentValue, setCurentValue] = React.useState<any>(value)
    const handleChange = (data: any) => { setCurentValue(data.target.value); register.onChange(data) }
    return (
        <div className='SelectInput'>
            <label htmlFor="0" className='text-15'>{props.label || ""}</label>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={curentValue || props?.default?.value || null}
                label={props.label || ""}
                {...register}
                {...props}
                onChange={handleChange}
            >
                {props.choices.map(el => (
                    <MenuItem value={el.value}>{el.title}</MenuItem>
                ))}
            </Select>
        </div>
    )
}
export function SelectArrayInput({ register, value, ...props }: ISelectInput) {
    const [curentValue, setCurentValue] = React.useState<any>(value)
    const handleChange = (data: any) => { setCurentValue(data.target.value); register.onChange(data) }
    return (
        <div className='SelectInput'>
            <label htmlFor="0" className='text-15'>{props.label || ""}</label>
            <Select
                multiple
                multiline
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={curentValue || props?.default?.value || []}
                label={props.label || ""}
                {...register}
                {...props}
                onChange={handleChange}
            >
                {props.choices.map(el => (
                    <MenuItem value={el.value}>{el.title}</MenuItem>
                ))}
            </Select>
        </div>
    )
}

export function AutoCompleteInput({ register, ...props }: ISelectInput) {
    return (
        <div className='SelectInput'>
            <label htmlFor="0" className='text-15'>{props.label || ""}</label>
            <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={props.choices}
                sx={{ width: 300 }}
                value={props?.default?.value || {}}
                renderInput={(params) => <TextField {...params} label={props.label || ""} />}
                {...register}
            />
        </div>
    )
}
export function AutoCompleteArrayInput({ register, ...props }: ISelectInput) {
    return (
        <div className='SelectInput'>
            <label htmlFor="0" className='text-15'>{props.label || ""}</label>
            <Autocomplete
                multiple
                disablePortal
                id="combo-box-demo"
                options={props.choices}
                sx={{ width: 300 }}
                getOptionLabel={(option) => option.title}
                renderInput={(params) => <TextField {...params} label={props.label || ""} />}
                {...register}
                onChange={(e)=>{console.log('e', e)}}
            />
        </div>
    )
}

export default SelectInput